import { useQuery } from '@hooks/reactQuery';

import { getAlarmUsers } from '@api/common';

import { IUserListResponse } from '@interfaces/user/user';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { refetchOptions } from '@constants/common';
import { ALARM_USERS } from '@constants/queryKeys';

export const useQueryAlarmUsers = () => {
	const {
		data: users,
		isLoading: isLoadingUsers,
	} = useQuery<Array<IUserListResponse>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_USERS],
		queryFn: getAlarmUsers,
		select: (users) => {
			return users?.map((item) => ({
				...item,
				value: item.id,
				label: item.fullName,
			}));
		},
		...refetchOptions,
	});

	return {
		usersOptions: users || [],
		isLoadingUsers,
	};
};
